import { useEffect, useState } from 'react';
import {
  discoveryApiRef,
  fetchApiRef,
  useApi,
} from '@backstage/core-plugin-api';
import { useEntity } from '@backstage/plugin-catalog-react';
import Box from '@material-ui/core/Box';
import Chip from '@material-ui/core/Chip';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  badge: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.error.contrastText,
    fontWeight: 700,
  },
}));

// Reads the last known validation report (without triggering a new run) to badge the entity tab.
export function LinterTabTitle() {
  const classes = useStyles();
  const { entity } = useEntity();
  const discoveryApi = useApi(discoveryApiRef);
  const fetchApi = useApi(fetchApiRef);
  const [issueCount, setIssueCount] = useState<number | undefined>();

  const entityPath = `${entity.metadata.namespace ?? 'default'}/${
    entity.kind
  }/${entity.metadata.name}`;

  useEffect(() => {
    let cancelled = false;

    async function load() {
      try {
        const baseUrl = await discoveryApi.getBaseUrl('spectral-lint');
        const response = await fetchApi.fetch(
          `${baseUrl}/validation-report/${entityPath}`,
        );
        if (!response.ok || cancelled) return;
        const body = await response.json();
        if (!cancelled && body?.status === 'complete') {
          setIssueCount(body.findings?.length ?? 0);
        }
      } catch {
        // No report yet or the request failed — show the plain tab name.
      }
    }

    void load();
    return () => {
      cancelled = true;
    };
  }, [discoveryApi, fetchApi, entityPath]);

  return (
    <Box display="flex" alignItems="center" gridGap={8}>
      <span>Linter</span>
      {Boolean(issueCount) && (
        <Chip size="small" label={`${issueCount}`} className={classes.badge} />
      )}
    </Box>
  );
}
